export type RuleTitlePluralType = "Titles";
export const RULE_PLURAL_NAME = "TITLES";
export type RuleTitleType = "Title";
export const RULE_NAME = "TITLE";
